var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.6855C22.2523 17.6855 24.0781 15.8597 24.0781 13.6074C24.0781 11.3551 22.2523 9.5293 20 9.5293C17.7477 9.5293 15.9219 11.3551 15.9219 13.6074C15.9219 15.8597 17.7477 17.6855 20 17.6855Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 17.6856C29.6739 17.6856 30.8281 16.5313 30.8281 15.1074C30.8281 13.6836 29.6739 12.5293 28.25 12.5293C26.8261 12.5293 25.6719 13.6836 25.6719 15.1074C25.6719 16.5313 26.8261 17.6856 28.25 17.6856Z",
    fill: "#5C5F62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 17.6856C13.1739 17.6856 14.3281 16.5313 14.3281 15.1074C14.3281 13.6836 13.1739 12.5293 11.75 12.5293C10.3261 12.5293 9.17188 13.6836 9.17188 15.1074C9.17188 16.5313 10.3261 17.6856 11.75 17.6856Z",
    fill: "#5C5F62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2902 20.0006C13.2753 19.1692 12.3562 19.2792 11.1828 19.2792C9.42781 19.2792 8 20.6986 8 22.4428V27.562C8 28.3195 8.61828 28.9355 9.37859 28.9355C12.6611 28.9355 12.2656 28.9949 12.2656 28.7939C12.2656 25.1665 11.836 22.5063 14.2902 20.0006Z",
    fill: "#5C5F62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1172 19.2985C19.0676 19.1275 17.2862 19.3004 15.7496 20.5688C13.1781 22.6285 13.673 25.4017 13.673 28.7944C13.673 29.692 14.4033 30.436 15.3146 30.436C25.209 30.436 25.6028 30.7551 26.1896 29.4558C26.382 29.0164 26.3292 29.156 26.3292 24.9525C26.3292 21.6138 23.4383 19.2985 21.1172 19.2985Z",
    fill: "#5C5F62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8163 19.2791C27.6365 19.2791 26.7225 19.1702 25.709 20.0005C28.1448 22.4875 27.7335 24.9662 27.7335 28.7938C27.7335 28.996 27.4053 28.9354 30.5713 28.9354C31.3588 28.9354 31.9991 28.2974 31.9991 27.5132V22.4427C31.9991 20.6985 30.5713 19.2791 28.8163 19.2791Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.4eb7fb0f1f7541b908f1ddc6dd8a0091.svg";
export { ForwardRef as ReactComponent };